// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"b53bf627","221":"f27de4e3"}[chunkId] + ".chunk.js";
};